import { ALL, ZIPWHIP } from '@/constants/providers';
import Attachment from '@/classes/v2/Attachment.js';

/**
 * Provider Class.
 *
 * @typedef {Object} Provider
 *
 * @module Message
 **/
export default class Provider {

  /**
   * @constructor
   * @this {Provider}
   *
   * @param {Object} Provider details
   **/
  constructor({ providerId = ZIPWHIP.id }) {
    this.id = providerId;

    // Find the details based on id in the available providers.
    const providerDetails = ALL.find(provider => provider.id === providerId);
    if ( providerDetails ){
      this.abbrev = providerDetails.abbrev;
      this.requiresSegmentation = providerDetails.requiresSegmentation;
      this.maxSmsMessageLength = providerDetails.maxSmsMessageLength;
      this.maxMmsMessageLength = providerDetails.maxMmsMessageLength;
      this.maxFileSizeKb = providerDetails.maxFileSizeKb
    }
  }

  /**
   * Determine if the attachment is valid for the given provider.
   * @param file The file to inspect.
   * @return {boolean}
   */
  isValidAttachment(file) {
    if (!file) return false;

    return Attachment.isValidFileType(file.type) && Attachment.isValidFileSize(file.size, this.maxFileSizeKb);
  }
}
